module.exports = __webpack_public_path__ + "img/logo.cbf59669.svg";